import { Card, CardContent } from "@/components/ui/card";
import { Star, Quote } from "lucide-react";

export const Testimonials = () => {
  const testimonials = [
    {
      content: "Eles abraçaram o projeto com dedicação, entenderam os requisitos rapidamente e ofereceram suporte em todo o processo. O resultado? Um projeto rodando perfeitamente, com uma estrutura robusta! Obrigado pela parceria, e em breve estaremos juntos em novos projetos. Abraço!",
      author: "Leandro",
      role: "Gerente de TI",
      rating: 5
    },
    {
      content: "Tive uma excelente experiência trabalhando com a dataviBI! Eles foram extremamente profissionais e ágeis. Desde o início, demonstrando grande conhecimento e disposição para ajudar, garantindo que tudo saísse exatamente como eu precisava. Recomendo fortemente seus serviços.",
      author: "Rychard", 
      role: "Analista de Dados",
      rating: 5
    },
    {
      content: "Excelente profissional, certamente contratarei mais vezes. Fez o que precisava, rápido, com qualidade e atencioso. Recomendo 100%",
      author: "Rafael",
      role: "Diretor Comercial",
      rating: 5
    },
    {
      content: "Super rápido, atencioso e fácil comunicação. Recomendo e voltarei a trabalhar com eles",
      author: "Nayara",
      role: "Coordenadora de Marketing",
      rating: 5
    }
  ];

  return (
    <section id="depoimentos" className="py-20 bg-muted/30">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            O que dizem nossos <span className="gradient-text">clientes</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Depoimentos reais de clientes que transformaram seus negócios com nossas soluções
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Card 
              key={index} 
              className="border-0 bg-gradient-card hover:shadow-lg transition-all duration-300 animate-slide-up"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <CardContent className="p-8 relative">
                {/* Quote Icon */}
                <Quote className="h-8 w-8 text-accent/30 mb-4" />
                
                {/* Rating */}
                <div className="flex mb-6">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 text-accent fill-current" />
                  ))}
                </div>

                {/* Content */}
                <p className="text-foreground leading-relaxed mb-6 text-base">
                  "{testimonial.content}"
                </p>

                {/* Author */}
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-gradient-primary rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-semibold text-lg">
                      {testimonial.author.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-foreground">{testimonial.author}</h4>
                    <p className="text-muted-foreground text-sm">{testimonial.role}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="text-center mt-16">
          <div className="inline-flex items-center justify-center space-x-8 bg-white rounded-2xl p-6 shadow-card">
            <div className="flex items-center">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-6 w-6 text-accent fill-current" />
                ))}
              </div>
              <span className="ml-3 text-lg font-semibold">4.9/5</span>
            </div>
            <div className="w-px h-8 bg-border"></div>
            <div className="text-center">
              <div className="text-2xl font-bold text-primary">50+</div>
              <div className="text-sm text-muted-foreground">Clientes Satisfeitos</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};